import { Pergunta } from "../../util/Alertas";
import { FaPencil, FaEye, FaTrash } from "react-icons/fa6";

export function Table({
    data,
    columns,
    className = "",
    enableActions = false,
    keyField,
    onEdit,
    onDelete,
    disabledEdit = false,
    onView
}) {
    const handleDelete = async (row) => {
        if (await Pergunta("Deseja realmente excluir esse item?")) {
            onDelete && onDelete(row);
        }
    };

    return (
        <div className={`w-100 ${className}`}>
            {/* Desktop Table */}
            <div className="d-none d-sm-block table-responsive shadow rounded">
                <table className="table table-striped">
                    <thead className="">
                        <tr>
                            {enableActions && (
                                <th style={{ width: 150 }}>
                                    Ações
                                </th>
                            )}
                            {columns.map((col, idx) => (
                                <th key={idx} style={{ maxWidth: 200 }}>
                                    {col.header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={idx}>
                                {enableActions && keyField && (
                                    <td>
                                        <div>
                                            {!disabledEdit && (
                                                <button
                                                    className="btn btn-sm text-white"
                                                    style={{ backgroundColor: "#FA6300" }}
                                                    onClick={() => onEdit?.(row)}
                                                >
                                                    <FaPencil />
                                                </button>
                                            )}
                                            <button
                                                className="btn btn-sm text-white"
                                                style={{ backgroundColor: "#462A71" }}
                                                onClick={() => onView?.(row)}
                                            >
                                                <FaEye />
                                            </button>
                                            <button
                                                className="btn btn-sm btn-danger text-white"
                                                onClick={() => handleDelete(row)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                )}
                                {columns.map((col, colIndex) => (
                                    <td style={{ maxWidth: 200 }} key={colIndex}>
                                        {col.render
                                            ? col.render(row[col.accessor], row)
                                            : row[col.accessor]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="d-block d-sm-none">
                <div className="d-flex flex-column gap-3">
                    {data.map((row, idx) => (
                        <div key={idx} className="card shadow-sm">
                            <div className="card-body p-3">
                                {columns.map((col, colIndex) => (
                                    <div key={colIndex} className="d-flex justify-content-between mb-2">
                                        <strong>{col.header}:</strong>
                                        <span>
                                            {col.render
                                                ? col.render(row[col.accessor], row)
                                                : row[col.accessor]}
                                        </span>
                                    </div>
                                ))}
                                {enableActions && keyField && (
                                    <div className="d-flex gap-2 mt-3">
                                        {!disabledEdit && (
                                            <button
                                                className="btn text-white flex-fill"
                                                style={{ backgroundColor: "#FA6300" }}
                                                onClick={() => onEdit?.(row)}
                                            >
                                                <FaPencil />
                                            </button>
                                        )}
                                        <button
                                            className="btn text-white flex-fill"
                                            style={{ backgroundColor: "#462A71" }}
                                            onClick={() => onView?.(row)}
                                        >
                                            <FaEye />
                                        </button>
                                        <button
                                            className="btn btn-danger text-white flex-fill"
                                            onClick={() => handleDelete(row)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
